import { useEffect, useMemo, useState } from "react";
import { DropBoxItem, DropBoxItemWrapper, DropBoxWrapper } from "./style";

interface TableDropBoxProps {
  list: { name: string; value: any; subValue?: any }[];
  value: any;
  setValue: (value: any) => void;
  subValue?: any;
  setSubValue?: (value: any) => void;
  isSearch?: boolean;
}

const TableDropBox = ({
  list,
  value,
  setValue,
  subValue,
  setSubValue,
  isSearch = false,
}: TableDropBoxProps) => {
  const [isDropOpen, setIsDropOpen] = useState<boolean>(false);
  const name = useMemo(
    () =>
      list.find(
        (item) =>
          item.value === value &&
          (subValue !== undefined ? item.subValue === subValue : true)
      )?.name ?? "",
    [value, subValue, list]
  );
  const [search, setSearch] = useState<string>(name);
  const [searchList, setSearchList] = useState<any[]>([]);

  useEffect(() => {
    if (search === "") {
      setSearchList(list);
      return;
    }
    const newList = list.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
    setSearchList(newList);
  }, [search, list]);

  useEffect(() => {
    setSearchList(list);
  }, [isDropOpen]);

  return (
    <DropBoxWrapper onClick={() => setIsDropOpen(!isDropOpen)}>
      {isSearch ? (
        <input
          value={search}
          onClick={(e) => {
            e.currentTarget.select();
            setIsDropOpen(!isDropOpen);
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      ) : (
        <div className="name">{name}</div>
      )}
      <img src="/image-web/edit/arrow_down.svg" alt="" />
      {isDropOpen && (
        <DropBoxItemWrapper>
          {!searchList.length && (
            <DropBoxItem selected={false}>검색 결과 없음</DropBoxItem>
          )}
          {(isSearch ? searchList : list).map((item, index) => (
            <DropBoxItem
              key={index}
              selected={
                item.value === value &&
                (subValue !== undefined ? item.subValue === subValue : true)
              }
              onClick={() => {
                setSearch(item.name);
                setValue(item.value);
                setSubValue && setSubValue(item.subValue);
              }}
            >
              {item.name}
            </DropBoxItem>
          ))}
        </DropBoxItemWrapper>
      )}
    </DropBoxWrapper>
  );
};

export default TableDropBox;
